import React, { createContext, useContext, useEffect, useState } from "react";
import {  useLocation, useHistory } from "react-router-dom";
import axios from "axios";
import {jwtDecode} from "jwt-decode";
const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    const [token, setToken] = useState(() => localStorage.getItem("accessToken"));
    const [role, setRole] = useState();
    const [loading, setLoading] = useState(true);
    
    const location = useLocation();
    const history = useHistory();
    const isTokenValid = async (token) => {
        if (!token) return false;
        try {
            const res = await axios.post(`/api/autenticacaonew/validate`, { token });
            return res.data.isValid;
        } catch (error) {
            console.error("Token inválido", error);
            logout();
            return false;
        }
    };

    useEffect(() => {
        const checkAuth = async () => {
            setLoading(true);
            const storedToken = localStorage.getItem("accessToken");
            setToken(storedToken);

            if (!storedToken || !(await isTokenValid(storedToken))) {
                logout();
            } else {
                try {
                    const decoded = jwtDecode(storedToken);
                    const userRole = decoded['http://schemas.microsoft.com/ws/2008/06/identity/claims/role'];
                    setRole(userRole);
                } catch (err) {
                    console.error("Erro ao decodificar token", err);
                    logout();
                }
            }
            setLoading(false);
        };

        checkAuth();
    }, [location]);

    useEffect(() => {
        const handleStorageChange = async () => {
            const storedToken = localStorage.getItem("accessToken");
            setToken(storedToken);

            if (!storedToken || !(await isTokenValid(storedToken))) {
                logout();
            }
        };
        window.addEventListener("storage", handleStorageChange);
        return () => window.removeEventListener("storage", handleStorageChange);
    }, []);
    
    const logout = () => {
        localStorage.removeItem("token");
        setToken(null);
        setRole(null);
        history.push("/");
    };
    
    return (
        <AuthContext.Provider value={{ token, role, logout, isTokenValid, loading }}>
            {children}
        </AuthContext.Provider>
    );
}
export function useAuth() {
    return useContext(AuthContext);
}
